'use client';

import { useEffect, useState } from 'react';

export default function LogoFull({
  className = '',
  variant,
  size = 192, // width in px (default ~ w-48)
}) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) return null;

  const logoVariant = 'black'

  const logoSrc =
    logoVariant === 'white'
      ? '/logos/Sangen Logo White.png'
      : '/logos/Sangen Logo black.png';

  // Example: original logo ratio 48:14 ≈ 3.43 (change if needed)
  const aspectRatio = 16 / 3;

  return (
    <div
      className={`relative`}
      style={{
        width: size,
        aspectRatio: `${aspectRatio}`,
      }}
    >
      <img
        src={logoSrc}
        alt="Sandgen Logo"
        className={`object-contain ${className}`}
      />
    </div>
  );
}
